"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EPhoneVerificationStatus;
(function (EPhoneVerificationStatus) {
  EPhoneVerificationStatus["Initial"] = "Initial";
  EPhoneVerificationStatus["SendingPhone"] = "SendingPhone";
  EPhoneVerificationStatus["SmsCodeSent"] = "SmsCodeSent";
  EPhoneVerificationStatus["SmsCodeSentError"] = "SmsCodeSentError";
  EPhoneVerificationStatus["CheckingSmsCode"] = "CheckingSmsCode";
  EPhoneVerificationStatus["CheckingSmsCodeError"] = "CheckingSmsCodeError";
  EPhoneVerificationStatus["PhoneVerificationSuccess"] = "PhoneVerificationSuccess";
})(EPhoneVerificationStatus || (EPhoneVerificationStatus = {}));
var _default = EPhoneVerificationStatus;
exports.default = _default;